import { OnInit, Component, Input, Output, EventEmitter } from '@angular/core';
import { ConfigurationService } from '../depends/configuration.service';
import { formatDate } from '@angular/common';
import {Company} from "../depends/company.model";
import moment from 'moment';
import 'moment-timezone';

export class TimelineEvent{
  constructor(
    public data?:any,
    public event_type?:string,
    public shape?:string,
    public start?:number,
    public end?:number,
    public color?:string,
    public background?:string,
    public nodelivery?: boolean
  ){}
}
export class TimelineRow{
  constructor(
    public label?:string,
    public events: TimelineEvent[] = []
  ){}
}

@Component({
  selector: 'NgxLoopTimeline',
  templateUrl: './ngx-loop-timeline.component.html',
  styleUrls: ['./ngx-loop-timeline.component.css' ]
})
export class NgxLoopTimelineComponent implements OnInit {

  company: Company;

  @Input()date: any = null;                                                                                             // tipo string / moment
  @Input()rows:TimelineRow[] = [];
  @Input()showEventTypes:string[] = [];
  @Input()startTime:number = 0;
  @Input()endTime:number = 23;

  @Output()onEventMouseClick:EventEmitter<any> = new EventEmitter<any>();
  @Output()onEventMouseHover:EventEmitter<any> = new EventEmitter<any>();

  startDateTimestamp:number = null;
  endDateTimestamp:number = null;
  timeLabels:string[] = [];

  constructor(
    private configurationService:ConfigurationService,
  ) {
    this.company = this.configurationService.getCompany();
  }

  ngOnInit() {

    if(this.date == null){
      this.date = moment(new Date()).tz(this.company.timezone);
    }
    else{
      this.date = moment.tz(this.date, "YYYY-MM-DD", this.company.timezone)
    }
    this.startDateTimestamp = this.date.hours(this.startTime).minutes(0).seconds(0).unix();
    this.endDateTimestamp = this.date.hours(this.endTime).minutes(59).seconds(59).unix();

    this.setChart();
  }

  setChart(){
    this.timeLabels = [];
    for(let i=this.startTime; i <= this.endTime + 1; i++){
      let label = ((i<10)?'0'+i:i).toString();
      this.timeLabels.push(label+":00");
    }
  }

  public getEventStyle(event:TimelineEvent){
    let style = {};
    let evt = {...event};

    if(evt.end < this.startDateTimestamp){
      let date_start = moment.unix(this.startDateTimestamp);
      let evt_date_end = moment.unix(evt.end).set("date",moment(this.date).date());
      let dif = evt.end - evt.start;
      let date_string = date_start.format('YYYY-MM-DD')+' '+evt_date_end.format('HH:mm:ss');
      dif = moment(date_string).unix() - moment.unix(evt.end).unix();
      evt.start = moment.unix(evt.start).unix() + dif;
      evt.end =  moment.unix(evt.end).unix() + dif;
    }

    evt.start = moment.unix(evt.start).tz(this.company.timezone).set("date",moment(this.date).date()).unix();
    evt.end =  moment.unix(evt.end).tz(this.company.timezone).set("date",moment(this.date).date()).unix();

    let dayDuration = this.endDateTimestamp-this.startDateTimestamp;
    let eventStartTimestamp = (evt.start >= this.startDateTimestamp)?evt.start:this.startDateTimestamp;
    if(evt.shape != "bar"){
      style = {
        color:evt.color,
        background:evt.background,
        width: '5px',
        height: '5px',
        'border-radius':'2.5px',
        left: `calc(${((100*(eventStartTimestamp - this.startDateTimestamp))/dayDuration).toFixed(2)}% - 2.5px)`
      };
    }else{
      let eventEndTimestamp = (evt.end <= this.endDateTimestamp)?evt.end:this.endDateTimestamp;
      let eventDuration = eventEndTimestamp - eventStartTimestamp;
      style = {
        color:evt.color,
        background:evt.background,
        width: `${((100*eventDuration)/dayDuration).toFixed(2)}%`,
        left: `${((100*(eventStartTimestamp - this.startDateTimestamp))/dayDuration).toFixed(2)}%`
      };
      if (evt.nodelivery)
        style['border-bottom'] = '4px solid #999';                                                                      // qdo a viagem nÃ£o tem delivery, adiciona uma borda em baixo pra simbolizar isso
    }
    if (!this.showEventTypes.includes(evt.event_type) || (!this.showEventTypes.includes('nodelivery') && evt.nodelivery == true))
      style["display"] = 'none';

    return style;
  }

  public emitMouseEventHover(event){
    this.onEventMouseHover.emit(event);
  }

  public emitMouseEventClick(event){
    this.onEventMouseClick.emit(event);
  }

  public formatTime(time){
    let locale = this.configurationService.getConfigLocale();
    if(locale != null){
      return formatDate(moment().format("YYYY-MM-DD")+" "+time+":00","shortTime", locale);
    }
    return time;
  }

}
